export default {
  TAXES: "Taxes",
  TAXES_LIST: "Liste des taxes",
  ADD_TAX: "Ajouter une taxe",
  TAX_ADDED: "Taxe ajoutée",
  EDIT_TAX: "Modifier une taxe",
  TAX_UPDATED: "Taxe mise à jour",
  DELETE_THIS_TAX: "Supprimer cette taxe ?",
  TAX_DELETED: "Taxe supprimée",
  VIEW_TAX: "Taxe",
  TYPE: "Type",
  SAME_TAXES:
    'Une ou plusieures taxes ont déjà été enregistrées avec le nom {name}. S\'agit-il de la même taxe ? Cliquez sur "Continuer" pour enregistrer si c\'est le cas, sinon cliquez sur "Annuler".',
  CREATED_AT: "Créée le",
  PERCENTAGE: "Pourcentage",
  AMOUNT: "Montant",
  DENOMINATION: "Dénomination",
  TRANSACTION: "Transaction",
  TRANSACTION_REQUIRED: "Veuillez préciser la transaction",
  SALES: "Vente",
  PURCHASES: "Achat",
  ACTIVE: "Active",
  DEACTIVATED: "Désactivée",
  VALUE: "Valeur",
  TAX_NUMBER: "Numero de taxe",
  CALCULATION_BASE: "Base de calcul",
  CALCULATION_BASE_REQUIRED: "Veuillez préciser la base de calcul",
  AFTER_TAX: "Montant apres taxe",
  BEFORE_TAX: "Montant avant taxe",
  ACTIVATION: "Activation",
  NO_TAXES_FOUND: "Aucune taxe trouvée",
  SELECTED_TAXES: "Taxes sélectionnées",
  CALCULATION_TYPE: "Type de calcul",
  DENOMINATION_REQUIRED: "Veuillez saisr la dénomination",
  NAME_REQUIRED: "Veuillez entrer le nom",
  AMOUNT_REQUIRED: "Veuillez entrer le montant",
  PERCENTAGE_REQUIRED: "Veuillez préciser le pourcentage",
  TYPE_REQUIRED: "Veuillez sélectionner le type",
  SELECT: "Sélectionner une taxe",
  SELECT_TAXES: "Ajouter des taxes",
  REQUIRED: "Veuillez sélectionner les taxes à ajouter",

  // Tax Groups
  TAX_GROUPS: "Groupes de taxes",
  TAX_GROUPS_LIST: "Liste des groupes de taxes",
  ADD_TAX_GROUP: "Ajouter un groupe de taxes",
  TAX_GROUP_ADDED: "Groupe ajouté",
  EDIT_TAX_GROUP: "Modifier un groupe",
  TAX_GROUP_UPDATED: "Groupe mise à jour",
  DELETE_THIS_TAX_GROUP: "Supprimer ce groupe de taxes ?",
  TAX_GROUP_DELETED: "Groupe supprimé",
  VIEW_TAX_GROUP: "Groupe de taxes",
  SAME_TAX_GROUPS:
    'Un ou plusieurs groupes ont déjà été enregistrés avec le nom {name}. S\'agit-il du même groupe ? Cliquez sur "Continuer" pour enregistrer si c\'est le cas, sinon cliquez sur "Annuler".',
  EDIT_TAXES: "Modifier les taxes",
  TAX_GROUP_REQUIRED: "Veuillez sélectionner le groupe de taxes applicable",
  COUT: "Coût",
  COUNTRY_CODE: "Code pays",
  COUNTRY_CODE_REQUIRED: "Veuillez préciser le code pays",
  TAX_GROUP_SELECT: "Sélectionner un groupe de taxes",
  NO_TAX_GROUPS_FOUND: "Aucun groupe de taxes trouvé",
};
